// src/utils/documentLabels.ts

export const labelMapping: Record<string, { label: string; description: string }> = {
  // Altre fonti generali
  amf_italy_report: {
    label: 'Report AMF Italia',
    description: 'Configura il report AMF Italia',
  },
  market_makers_borsa_italiana: {
    label: 'Market Maker Borsa Italiana',
    description: 'Configura i Market Maker censiti da Borsa Italiana',
  },
  market_makers_other_exchanges: {
    label: 'Market Maker altre borse',
    description: 'Configura i Market Maker censiti da altre borse',
  },

  // Fonti bancarie
  best_execution_strategy: {
    label: 'Best Execution Strategy',
    description: 'Configura le fonti di tipo "Strategia ed esecuzioni degli ordini"',
  },
  non_financial_statements: {
    label: 'Non Financial Statements',
    description: 'Configura altre fonti (esempio Report di sostenibilità) da utilizzare per identificazione di GAR e CET1',
  },
  execution_venues: {
    label: 'Sedi di esecuzione',
    description: 'Configura fonti aggiuntive contenenti le sedi di esecuzioni',
  },
  pillar_iii: {
    label: 'Pillar III',
    description: 'Configura le fonti relative a Basel III Pillar III',
  },
  financial_statements: {
    label: 'Bilancio consolidato',
    description: 'Configura le fonti di tipo "Bilancio consolidato"',
  },
  claims: {
    label: 'Reclami',
    description: 'Configura le fonti di tipo "Rendiconto di gestione dei reclami"',
  },
};
